import styled, { css } from 'styled-components';

export const StyledHeader = styled.div<{
    flex?: number;
    padding?: number | string;
    textAlign?: string;
    width?: string | number;
    debug?: boolean;
    background?: string;
    display?: string;
    displayMode?: 'flex' | 'table';
  }>`
  flex: ${({ flex }) => flex};
  padding: ${({ padding = 12 }) => typeof padding === 'number' ? `${padding}px` : padding};
  font-weight: bold;
  text-align: ${({ textAlign }) => textAlign || 'left'};
  color: ${({ color }) => color};
  font-size: 14px;
  box-sizing: border-box;
  display: ${({ displayMode, display }) => displayMode === 'table' ? 'table-cell' : (display || 'block')};
  background: ${({ background }) => background};

  ${({ textAlign }) => textAlign === 'right' && css`
    justify-content: flex-end;
  `}

  ${({ textAlign }) => textAlign === 'center' && css`
    justify-content: center;
  `}

  ${({ width }) => width && css`
    min-width: ${typeof width === 'number' ? `${width}px` : width};
    max-width: ${typeof width === 'number' ? `${width}px` : width};
  `}

  ${({ debug }) => debug && css`
    outline: 1px solid green;
  `}
`;
